
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42","height":"52.415"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"長方形 936","fill":"#12b6d4","d":"M0 0h42v52.415H0z"}})])]),_c('g',{attrs:{"data-name":"グループ 312","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"パス 474","d":"M40.213.251L.4 32.849a1.093 1.093 0 00.855 1.926l19.568-2.942a1.532 1.532 0 011.682 1.036l6.188 18.8a1.093 1.093 0 002.1-.1L41.972 1.334A1.093 1.093 0 0040.213.251","fill":"#12b6d4"}})])])
          )
        }
      }
    